import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Finance.ClaimJobPayment.Export.IRequest;
type Response = Api.Finance.ClaimJobPayment.Export.IResponse;
type Headers = Api.Finance.ClaimJobPayment.Export.IHeaders;
const url = '/api/Finance/ClaimJobPayment/ExportToExcel';
export default async function claimJobPaymentExportApi(query: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(url, null, query),
    headers: getDefaultHeaders(),
  });
}
